export default {
    'parent': 'ouder',
    'parents': 'ouders',
    'address': 'adres',
    'address.street': 'straat',
    'address.number': 'huisnummer',
    'address.postalCode': 'postcode',
    'address.city': 'gemeente',
    'address.country': 'land',
    'email': 'e-mailadres',
    'emails': 'e-mailadressen',
    'phone': 'GSM-nummer',
    'firstName': 'voornaam',
    'lastName': 'achternaam',
    'nationalRegisterNumber': 'rijksregisternummer',
    'birthDay': 'geboortedatum',
    'dataPermissions': 'toestemming gegevensverwerking',
    'notes': 'notities',
    'name': 'naam',
    'description': 'omschrijving',
    'isLocationRequired': 'locatie verplicht',
    'membershipType': 'aansluitingstype',
    'membershipTypes': 'aansluitingen en verzekeringen',
    'period': 'werkjaar',
    'periods': 'werkjaren',
    'responsibility': 'functie',
    'responsibilities': 'functies',
    'recordsConfiguration': 'persoonsgegevens',
    'defaultAgeGroups': 'standaard leeftijdsgroepen',
    'defaultAgeGroup': 'standaard leeftijdsgroep',
    'eventTypes': 'soorten activiteiten',
    'eventType': 'soort activiteit',
    'horizontalLogo': 'horizontaal logo',
    'squareLogo': 'vierkant logo',
    'logoDocuments': 'logo op documenten',
    'color': 'huisstijlkleur',
    'price': 'prijs',
    'price.price': 'prijs',
    'price.reducedPrice': 'verlaagd tarief',
    'prices': 'prijzen',
    'minimumMembers': 'minimum aantal',
    'locked': 'vergrendeld',
    'on': 'aan',
    'off': 'uit',
    'uitpasNumber': 'uitpasnummer',
    'alwaysEnabledAndRequired': 'altijd ingeschakeld en verplicht',
    'alwaysEnabledAndOptional': 'altijd ingeschakeld en optioneel',
    'sometimesEnabledAndOptional': 'soms ingeschakeld en optioneel',
    'alwaysEnabledAndSometimesRequired': 'altijd ingeschakeld en soms verplicht',
    'sometimesEnabledAndRequired': 'soms ingeschakeld en verplicht',
    'sometimesEnabledAndSometimesRequired': 'soms ingeschakeld en soms verplicht',
    'emergencyContact': 'noodcontactpersoon',
    'emergencyContacts': 'noodcontactpersonen',
    'roles': 'externe beheerdersrollen',
    'role': 'externe beheerdersrol',
    'location': 'locatie',
    'securityCode': 'beveiligingscode',
    'defaultEmailId': 'standaard e-mailadres',
    'allowRegistrationsByOrganization': 'inschrijvingen door groep toelaten',
    'title': 'titel',
    'requiresFinancialSupport': 'financiële ondersteuning',
    'alternativeEmail': 'alternatief e-mailadres',
    'alternativeEmails': 'alternatieve e-mailadressen',
    'default': 'standaard',
    'paymentConfiguration': 'betaalinstellingen',
    'registrationPaymentConfiguration': 'betaalinstellingen voor inschrijvingen',
    'paymentMethod': 'betaalmethode',
    'paymentMethods': 'betaalmethoden',
    'premiseTypeId': 'type lokaal',
    'premises': 'lokalen',
    'premise': 'lokaal',
    'group': 'groep',
    'defaultAgeGroupId': 'standaard leeftijdsgroep',
    'inheritedResponsibilityRoles': 'ingebouwde functies',
    'resource': 'toegang tot',
    'level': 'toegangsniveau',
    'accessRight': 'toegangsrecht',
    'permissions': 'rechten',
    'permission': 'recht',
    'None': 'geen rechten',
    'Read': 'lezen',
    'Write': 'bewerken',
    'Full': 'volledige toegang',
    'WebshopScanTickets': 'tickets scannen',
    'EventWrite': 'activiteiten bewerken',
    'MemberManageNRN': 'rijksregisternummers beheren',
    'MemberWriteFinancialData': 'financiële gegevens bewerken',
    'MemberReadFinancialData': 'financiële gegevens lezen',
    'OrganizationCreateGroups': 'groepen aanmaken',
    'OrganizationFinanceDirector': 'toegang tot volledige boekhouding',
    'OrganizationManagePayments': 'overschrijvingen beheren',
    'PlatformLoginAs': 'inloggen als hoofdbeheerder',
    'inheritedRecordCategory': 'ingebouwde gegevens',
    'inheritedRecordCategories': 'ingebouwde gegevens',
    'freeContribution': 'vrije bijdrage',
    'amount': 'bedrag',
    'organizationTagId': 'regio',
    'richText': 'tekst',
    'checkbox': 'aankruisvakje',
    'recordCategories': 'vragenlijsten',
    'recordCategory': 'vragenlijst',
    'record': 'vraag',
    'records': 'vragen',
    'required': 'verplicht',
    'Text': 'tekstveld',
    'childCategories': 'categorieën',
    'defaultEnabled': 'standaard ingeschakeld',
    'paymentMethodSettings': 'betaalinstellingen',
    'paymentMethodSetting': 'betaalinstelling',
    'optionMenus': "keuzemenu's",
    'optionMenu': 'keuzemenu',
    'options': 'keuzes',
    'option': 'keuze',
    'allowAmount': 'meerdere stuks',
    'recordAnswers': 'gegevens',
    'recordAnswer': 'gegeven',
    'nationalRegisterNumberOptOut': 'geen Belgische nationaliteit',
    'unchecked': 'niet aangevinkt',
    'checked': 'aangevinkt',
    'groupId': 'inschrijvingsgroep',
    'groupIds': 'inschrijvingsgroepen',
    'registrations': 'inschrijvingen',
    'registration': 'inschrijving',
    'waitingList': 'wachtlijst',
    'registrationPeriods': 'werkjaren',
    'registrationPeriod': 'werkjaar',
    'categories': 'categorieën',
    'category': 'categorie',
    'categoryIds': 'categorieën',
    'setupSteps.steps': 'vlagmoment',
    'setupSteps': 'vlagmoment',
    'reviewedBy': 'nagekeken door',
    'reviewedAt': 'nagekeken op',
    'steps': 'stappen',
    'products': 'artikels',
    'product': 'artikel',
    'transferSettings': 'overschrijvingsinstellingen',
    'iban': 'IBAN',
    'stock': 'voorraad',
    'usedStock': 'aantal verkocht',
    'untitled': 'naamloos',
    'prices.untitled': 'standaard prijs',
    'phoneEnabled': 'GSM-nummer vragen',
    'notificationEmail': 'Meldingen naar e-mailadres',
    'cart.items': 'bestelde artikels',
    'cart.item': 'besteld artikel',
    'cart': 'winkelmandje',
    'administrationFee': 'administratiekost',
    'totalPrice': 'totaalprijs',
    'customer': 'besteller',
    'memberNumber': 'lidnummer',
    'number': 'nummer',
    'paidAt': 'betaald op',
    'startDate': 'startdatum',
    'endDate': 'einddatum',
    'ibanName': 'naam op bankkaart',
    'organizationCount': 'aantal groepen',
    'fieldAnswers': 'antwoorden',
    'fieldAnswer': 'antwoord',
    'updatesEnabled': 'automatisch wijzigen',
    'html': 'inhoud',
    'password': 'wachtwoord',
    'emailVerified': 'e-mailadres geverifieerd',
    'linkedMember': 'gekoppeld lid',
    'permissions.organizationPermissions': 'groepsrechten',
    'balanceNotificationSettings': 'betaalherinneringen',
    'balanceNotificationSettings.organizationContactsFilter.meta.responsibilityIds.$in': 'Betaalherinnering naar verenigingen: functies',
    'reviewTimes.times': 'laatst nagekeken',
    'reviewTime.details': 'algemene gegevens',
    'reviewTime.parents': 'ouders',
    'reviewTime.emergencyContacts': 'noodcontactpersonen',
    'reviewTime.records': 'persoonsgegevens',
    'reviewTime.uitpasNumber': 'UiTPAS-nummer',
    'reviewTimes': 'laatst nagekeken',
    'updatedAt': 'laatst gewijzigd op',
    'showInMemberPortal': 'tonen in ledenportaal',
    'bundleDiscounts': 'bundelkortingen',
};
//# sourceMappingURL=audit-log-words.js.map